<template>
    <a-badge-ribbon :text="my_service.current_stage" :color="colorStage(my_service.current_stage)">
        <a-card
            :bodyStyle="{ paddingLeft: '8px',  paddingRight: '8px',  paddingTop: '10px'}"
        >
            <template #title>
                <span class="card_title">{{ TitleCut(my_service.display_name)[1] }}</span>
            </template>
            <a-row v-if="my_service.service_type == 'FTTH' || my_service.service_type == 'WISP' " gap="middle" align="end" justify="space-around" style="margin-bottom: 10px;">
                <WidgetSpeed 
                :valueUp="my_service.service_upload" 
                :valueDown="my_service.service_download" 
                :vertical="layout_speed_vertical"
                />
            </a-row>
            <a-row v-if="my_service.service_type == 'COAX' || my_service.service_type == 'IPTV'" gap="middle" align="end" justify="space-around" style="margin-bottom: 10px;">
                <WidgetServiceIptv 
                :my_service="my_service"
                />
            </a-row>
            <a-row gap="middle" align="center" justify="space-around">
                <WidgetServiceInfo 
                :my_service="my_service" 
                :layout_info_vertical="layout_info_vertical"
                />
            </a-row>
            <!-- <a-flex gap="middle" align="center" justify="space-around">
                <WidgetServiceAction
                :my_service="my_service" 
                />
            </a-flex> -->
        </a-card>
    </a-badge-ribbon>
</template>
<script>
import WidgetSpeed from '@/components/Widgets/WidgetSpeed'
import WidgetServiceInfo from '@/components/Widgets/WidgetServiceInfo'
import WidgetServiceIptv from '@/components/Widgets/WidgetServiceIptv'
import WidgetServiceAction from '@/components/Widgets/WidgetServiceAction'
import { TitleServiceCut }  from '@/plugins/odoo_table'

export default ({
    components: {
        WidgetSpeed, WidgetServiceInfo, WidgetServiceIptv, WidgetServiceAction
    },
    props: {
        my_service: {
            type: Object,
            required: true
        },
        layout_speed_vertical: {
            type: Boolean,
            default: false
        },
        layout_info_vertical: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        TitleCut(display_name) {
            let arrayCut = TitleServiceCut(display_name);
            arrayCut[1] = this.formatString(arrayCut[1]);
            return arrayCut
        },
        formatString(input, cant = 27) {
            let result = "";
            let currentLine = "";
            let lastSpaceIndex = -1;
            for (let i = 0; i < input.length; i += cant) {
                let substring = (lastSpaceIndex == -1) ? input.slice(i, i + cant) :  input.slice(lastSpaceIndex, lastSpaceIndex + cant);
                lastSpaceIndex = substring.lastIndexOf(" ");
                if (lastSpaceIndex !== -1) {
                    if (i + cant < input.length) {
                        currentLine += substring.slice(0, lastSpaceIndex) + "\n";
                    } else {
                        currentLine += substring;
                    }
                } else {
                    currentLine += substring;
                }
                lastSpaceIndex += i + 1
                
            }
            return currentLine.trim();
        },
        colorStage(status) {
            switch(status) {
                case "Activo":
                    return "green"
                case "Suspendido":
                    return "red"
            }
        }
    }
})
</script>
<style>
.card_title {
    font-weight: bold; 
    white-space: pre-line; 
    text-align: center; 
    display: block;
    margin-right: 40px !important;
}
.card_short_margin {
    padding-left: '4px';
    padding-right: '4px';
    padding-top: '10px'
}
.title_service {    
    color: rgba(0, 0, 0, 0.88);
    font-size: 16px;
    font-weight: 500;
}
.widget_service {
    font-size: 20px;
    text-align: center;
    font-weight: 700;
}
</style>